import {
  Box,
  Button,
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { DataHubVisitors } from "../types/types";
import TableFooterpagination from "../components/TableFooterPagination";
import useAfasData from "../hooks/useAfasData";

const BusinessVisitors = () => {
  const [visitors, setVisitors] = useState<DataHubVisitors[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  const {
    data: remoteVisitors,
    isLoading: remoteVisitorsLoading,
    status: statusVisitors,
  } = useAfasData("/datahub/visitors");

  useEffect(() => {
    if (statusVisitors === "success") {
      setVisitors(remoteVisitors);
    }
  }, [statusVisitors, remoteVisitors]);

  return (
    <Box mb={2}>
      <Card>
        {remoteVisitorsLoading && !remoteVisitors && <LinearProgress />}
        {!remoteVisitorsLoading && !remoteVisitors && (
          <Typography variant="body1">Geen data gevonden</Typography>
        )}
        {!remoteVisitorsLoading && remoteVisitors && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Naam</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Categorie</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Sessies</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Actie</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? visitors.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : visitors
              ).map((visitor) => (
                <TableRow key={visitor.Name}>
                  <TableCell>{visitor.Name}</TableCell>
                  <TableCell>
                    <Tooltip placement="top-start" title={visitor["Bedrijven sbi_categorie"]}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "inherit",
                          maxWidth: "160px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {visitor["Bedrijven sbi_categorie"]}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{visitor.Sessions}</TableCell>
                  <TableCell>
                    <Button
                      href={visitor["Pop-up URL"]}
                      target="_blank"
                      size="small"
                      variant="contained"
                      color="primary"
                    >
                      Bekijk
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooterpagination
              count={visitors.length}
              page={page}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />
          </Table>
        )}
      </Card>
    </Box>
  );
};

export default BusinessVisitors;
